// Navbar.jsx

import React, { useState } from "react";
import { Menu, Icon, Input, Button, Image, Grid } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import "../styles/UserNavbar.css";

const UserNavbar = ({
  setToggle,
  navTitle,
  type,
  handleOpenUserAdd,
  showDatasetCount,
  NavbarCollapse,
  userSearchData,
}) => {
  const navBarTitle = navTitle || "Q&A";
  const [inputValue, setInputValue] = useState("");

  const handleInputChange = (event) => {
    setInputValue(event.target.value.toLowerCase());
    userSearchData(event.target.value.toLowerCase());
  };
  const navigate = useNavigate();

  const handleBack = async () => {
    navigate(`/dataconsole`);
  };

  return (
    <Menu fixed="top" className="navbar" borderless style={{ zIndex: "0" }}>
      <Menu.Menu className={`${!NavbarCollapse ? "" : "navbar-collapse"}`}>
        {/* Mobile View  and desktop view*/}
        {!NavbarCollapse ? (
          <Grid>
            <React.Fragment>
              <Menu.Item className="menu-item-left">
                {/* Mobile view */}
                <div onClick={setToggle} className="mobile-sidebar-icon">
                  <Image src="/images/mobile_menu.svg" alt="Menu Icon" />
                </div>
                {/* Mobile view end */}
                {type === "all_users" && (
                  <>
                    <Image src="/images/all-users.svg" alt="Data Console" />
                  </>
                )}
                {type === "groups" && (
                  <>
                    <Image src="/images/requests.svg" alt="Groups" />
                  </>
                )}
                {type === "add_doc" && (
                  <>
                    <Image
                      className="backButton"
                      onClick={handleBack}
                      src="/images/Back.svg"
                      alt="Back Button"
                    />
                    <Image src="/images/Dataset.svg" alt="Dataset" />
                  </>
                )}
                <label>{navBarTitle || "Default"}</label>
              </Menu.Item>
            </React.Fragment>
            {type === "all_users" && (
              <>
                <Menu.Item className="menu-item-data-consoles">
                  <div className="tag">{showDatasetCount || 0} Users</div>
                </Menu.Item>
                <Menu.Item>
                  <div className="menu-item-search">
                    <input
                      type="text"
                      id="landingSearchMobile"
                      value={inputValue}
                      onChange={(e) => setInputValue(e.target.value)}
                      placeholder=" "
                      data-cy="dataset-search-input"
                    />
                    <label htmlFor="landingSearchMobile">
                      <img src="/images/search.svg" alt="Logo" />
                      Search
                    </label>
                  </div>
                  {NavbarCollapse}
                </Menu.Item>
              </>
            )}
          </Grid>
        ) : (
          <Grid>
            <React.Fragment>
              <Menu.Item className="menu-item-left">
                {/* Mobile view */}
                <div onClick={setToggle} className="mobile-sidebar-icon">
                  <Image src="/images/mobile_menu.svg" alt="Menu Icon" />
                </div>
                {/* Mobile view end */}
                {type === "all_users" && (
                  <>
                    <Image src="/images/all-users.svg" alt="Data Console" />
                  </>
                )}
                <label>
                  {navBarTitle.length < 25
                    ? navBarTitle
                    : navBarTitle.slice(0, 24) + "..." || "Default"}
                </label>
              </Menu.Item>
            </React.Fragment>
            {/*Desktop landing Page */}
            {type === "all_users" && (
              <>
                <Menu.Item className="menu-item-data-consoles">
                  <div className="tag">{showDatasetCount || 0} Users</div>
                </Menu.Item>
                <Menu.Item>
                  <div className="menu-item-search">
                    <input
                      type="text"
                      id="landingSearchDesktop"
                      value={inputValue}
                      onChange={handleInputChange}
                      placeholder=""
                      data-cy="dataset-search-input"
                    />
                    <label htmlFor="landingSearchDesktop">
                      <img src="/images/search.svg" alt="Logo" />
                      Search
                    </label>
                  </div>
                  {NavbarCollapse}
                </Menu.Item>
              </>
            )}
          </Grid>
        )}
      </Menu.Menu>

      {/* Right-aligned content */}
      <Menu.Menu position="right">
        <React.Fragment>
          {type === "all_users" && (
            <Menu.Item className="hide-add-dataset-button-desktop">
              <Button
                primary
                onClick={handleOpenUserAdd}
                className="button-data-console"
                data-cy="add-dataset-btn-link"
              >
                <div className="button-data-console-parent">
                  <Image
                    src="/images/white-base-icons.svg"
                    alt="Add new user"
                  />
                  Add new user
                </div>
              </Button>
            </Menu.Item>
          )}
          {/* <Menu.Item position="right">
            <img
              src="/images/filter.svg" // Using the imported delete image
              alt="Vie More"
              // onClick={() => handleDelete(row.id)}
              style={{ cursor: "pointer" }}
            />
          </Menu.Item> */}
        </React.Fragment>
      </Menu.Menu>
    </Menu>
  );
};

export default UserNavbar;
